(function() {

  /* ── Pricing data ── */
  var prices = {
    1: {
      subscribe: { was: '$59.99', now: '$44.99', daily: '$1.50 a day', renewal: 'Renews every 30 days', saveLine: 'Save $15 vs buying once' },
      onetime:   { was: '',       now: '$59.99', daily: '$2.00 a day', renewal: 'No renewal', saveLine: '' }
    },
    3: {
      subscribe: { was: '$59.99', now: '$35.99', daily: '$1.20 a day', renewal: 'Renews every 90 days', saveLine: 'Save $27 vs buying once' },
      onetime:   { was: '$59.99', now: '$44.99', daily: '$1.50 a day', renewal: 'No renewal', saveLine: '' }
    },
    6: {
      subscribe: { was: '$59.99', now: '$29.99', daily: '$0.99 a day', renewal: 'Renews every 180 days', saveLine: 'Save $36 vs buying once' },
      onetime:   { was: '$59.99', now: '$35.99', daily: '$1.20 a day', renewal: 'No renewal', saveLine: '' }
    }
  };

  var tinLabels = { 1: '1 tin', 3: '3 tins', 6: '6 tins' };

  /* ── Event delegation on document ── */
  document.addEventListener('click', function(e) {
    var target = e.target;

    // Mobile menu
    if (target.closest('.mobile-menu-btn')) {
      var nav = document.querySelector('.header-nav');
      var btn = target.closest('.mobile-menu-btn');
      if (nav) {
        nav.classList.toggle('open');
        btn.textContent = nav.classList.contains('open') ? '✕' : '☰';
      }
      return;
    }

    // PDP supply option click
    var supplyOpt = target.closest('.supply-option');
    if (supplyOpt) {
      var parent = supplyOpt.closest('.supply-options') || supplyOpt.closest('.pdp-form');
      if (parent) {
        var all = parent.querySelectorAll('.supply-option');
        for (var i = 0; i < all.length; i++) all[i].classList.remove('selected');
      }
      supplyOpt.classList.add('selected');
      updatePDP();
      return;
    }

    // PDP purchase type click
    var purchaseType = target.closest('.purchase-type');
    if (purchaseType) {
      var ptParent = purchaseType.closest('.purchase-types');
      if (ptParent) {
        var allPt = ptParent.querySelectorAll('.purchase-type');
        for (var j = 0; j < allPt.length; j++) allPt[j].classList.remove('selected');
      }
      purchaseType.classList.add('selected');
      updatePDP();
      return;
    }

    // Homepage buy toggle
    var buyToggle = target.closest('.buy-toggle__btn');
    if (buyToggle) {
      var toggleParent = buyToggle.closest('.buy-toggle');
      if (toggleParent) {
        var allBtns = toggleParent.querySelectorAll('.buy-toggle__btn');
        for (var k = 0; k < allBtns.length; k++) allBtns[k].classList.remove('active');
      }
      buyToggle.classList.add('active');
      var tgt = buyToggle.getAttribute('data-target');
      var sec = buyToggle.closest('.buy-section') || buyToggle.closest('.hp-buy');
      if (sec) {
        var groups = sec.querySelectorAll('.buy-options-group');
        for (var l = 0; l < groups.length; l++) groups[l].style.display = 'none';
        var activeGroup = sec.querySelector('[data-group="' + tgt + '"]');
        if (activeGroup) activeGroup.style.display = 'flex';
      }
      return;
    }

    // Homepage buy option click
    var buyOpt = target.closest('.buy-option');
    if (buyOpt) {
      var optParent = buyOpt.closest('.buy-options-group') || buyOpt.closest('.buy-options');
      if (optParent) {
        var allOpts = optParent.querySelectorAll('.buy-option');
        for (var m = 0; m < allOpts.length; m++) allOpts[m].classList.remove('selected');
      }
      buyOpt.classList.add('selected');
      return;
    }

    // Product image thumb click
    var thumb = target.closest('.pdp-images__thumb');
    if (thumb) {
      var mainImg = document.querySelector('.pdp-images__main');
      if (mainImg && mainImg.tagName === 'IMG') {
        mainImg.src = thumb.getAttribute('data-full') || thumb.src;
        mainImg.alt = thumb.alt;
      }
      var allThumbs = document.querySelectorAll('.pdp-images__thumb');
      for (var n = 0; n < allThumbs.length; n++) allThumbs[n].classList.remove('active');
      thumb.classList.add('active');
      return;
    }
  });

  /* ── Update PDP pricing + button ── */
  function updatePDP() {
    var selectedSupply = document.querySelector('.supply-option.selected');
    if (!selectedSupply) return;
    var months = parseInt(selectedSupply.getAttribute('data-months'), 10) || 3;
    var data = prices[months];
    if (!data) return;

    // Update subscribe box
    var subBox = document.querySelector('.purchase-type[data-type="subscribe"]');
    if (subBox) {
      setText(subBox, '.purchase-type__was', data.subscribe.was);
      setText(subBox, '.purchase-type__now', data.subscribe.now);
      setText(subBox, '.purchase-type__daily', data.subscribe.daily);
      setText(subBox, '.purchase-type__renewal', data.subscribe.renewal);
      var perks = subBox.querySelectorAll('.purchase-type__perk');
      if (perks.length >= 2) perks[1].textContent = data.subscribe.saveLine;
    }

    // Update one-time box
    var otBox = document.querySelector('.purchase-type[data-type="onetime"]');
    if (otBox) {
      var wasEl = otBox.querySelector('.purchase-type__was');
      if (wasEl) {
        wasEl.textContent = data.onetime.was;
        wasEl.style.display = data.onetime.was ? '' : 'none';
      }
      setText(otBox, '.purchase-type__now', data.onetime.now);
      setText(otBox, '.purchase-type__daily', data.onetime.daily);
      setText(otBox, '.purchase-type__renewal', data.onetime.renewal);
    }

    // Update add-to-cart button
    var atcBtns = document.querySelectorAll('.pdp-atc button, .pdp-atc .btn--primary, .pdp-atc input[type="submit"]');
    for (var i = 0; i < atcBtns.length; i++) {
      atcBtns[i].innerHTML = 'Add ' + tinLabels[months] + ' to cart →';
    }

    // Also try the broader selector
    var formBtn = document.querySelector('#pdp-buy-form ~ .pdp-review-quote ~ .pdp-atc button');
    if (!formBtn) formBtn = document.querySelector('.pdp-info .pdp-atc button');
    if (!formBtn) formBtn = document.querySelector('.pdp-atc button');
    if (formBtn) formBtn.innerHTML = 'Add ' + tinLabels[months] + ' to cart →';
  }

  function setText(parent, selector, value) {
    var el = parent.querySelector(selector);
    if (el) el.textContent = value;
  }

  /* ── Header scroll ── */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 10);
    });
  }

  /* ── Sticky bar on PDP ── */
  var stickyBar = document.querySelector('.sticky-bar');
  var pdpForm = document.querySelector('.pdp-form');
  if (stickyBar && pdpForm) {
    var observer = new IntersectionObserver(function(entries) {
      for (var i = 0; i < entries.length; i++) {
        stickyBar.classList.toggle('visible', !entries[i].isIntersecting);
      }
    }, { threshold: 0 });
    observer.observe(pdpForm);
  }

})();
